export default __webpack_public_path__ + "static/hero-b4cf912c751db0ad66d620700b689b4a.png";